export default __webpack_public_path__ + "static/media/Discover.cc916eb3.svg";